import { Box } from "@material-ui/core";
import React from "react";
import { useSelector } from "react-redux";

import SecondaryTable from "./SecondaryTable";

const BiddersTab = () => {
  const {
    adminContractDetails: { bidders = [] },
  } = useSelector((state) => state.admin);

  const secondaryTableHeader = [
    { id: "s/n", title: "#", width: 50, align: "alignCenter", indexed: true },
    { id: "companyName", title: "Company Name", grid: 3 },
    { id: "regName", title: "Registeration Name", grid: 3 },
    { id: "evalComment", title: "Evaluation Comment", grid: 3 },
    { id: "evalStatus", title: "Evaluation Status" },
  ];

  const tableBody = bidders.map((bidder) => ({
    companyName: bidder.companyName,
    regName: bidder.registrationNumber,
    evalComment: bidder.comment,
    evalStatus: bidder.status,
  }));

  return <Box style={{overflowX: "scroll"}}><SecondaryTable tableBody={tableBody} tableHeader={secondaryTableHeader} /></Box>;
};

export default BiddersTab;
